import { render, staticRenderFns } from "./AvatarList.vue?vue&type=template&id=612396ac&scoped=true"
import script from "./AvatarList.vue?vue&type=script&lang=ts"
export * from "./AvatarList.vue?vue&type=script&lang=ts"
import style0 from "./AvatarList.vue?vue&type=style&index=0&id=612396ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612396ac",
  null
  
)

export default component.exports